import { Form, Input, InputNumber } from "antd";
import { FormItemProps } from "antd/es/form";
import { InputNumberProps } from "antd/lib";
import { InputProps } from "antd/lib/input";
import style from "./FormItem.module.scss";

type InputFormItemProps<T> = FormItemProps<T> &
  Omit<InputProps | InputNumberProps, "name"> & {
    testId?: string;
  };

export const InputFormItem = <T extends object>({
  id,
  name,
  label,
  rules,
  testId,
  className,
  required,
  type,
  ...props
}: InputFormItemProps<T>) => {
  return (
    <Form.Item
      id={id}
      name={name}
      label={label}
      rules={rules}
      className={`${style.formItem} ${className}`}
      data-testid={testId}
      required={required}
    >
      {type === "number" ? (
        <InputNumber
          name={id}
          className={`${style.formItem} ${style.fontSize} ${style.formItemInput}`}
          style={{ width: "100%", alignItems: "center" }}
          {...(props as Omit<InputNumberProps, "children">)}
        />
      ) : (
        <Input
          name={id}
          className={`${style.fontSize} ${style.formItemInput}`}
          {...(props as InputProps)}
        />
      )}
    </Form.Item>
  );
};

export default InputFormItem;
